// extracted by mini-css-extract-plugin
module.exports = {"root":"Features-module__root___2oimS","image":"Features-module__image___2sChl","desc":"Features-module__desc___1Ou7x"};